export enum CouponExpiryStatus {
  EXPIRED = 'expired',
  WARNING = 'warning',
  OK = 'ok',
  USED = 'used',
  CLOSE_TO_EXPIRATION = 'closeToExpiration',
}
